import "./Popover.scss";

import React, { ReactNode } from "react";
import { Popper, PopperChildrenProps } from "react-popper";

import useMergedRefs from "./hooks/useMergedRefs";

interface Props {
  referenceElement: HTMLElement;
  interiorRef?: React.Ref<HTMLDivElement>;
  placement?: "top" | "left" | "bottom" | "right";
  children?: ReactNode;
  className?: string;
}

export default function Popover(props: Props) {
  const {
    referenceElement,
    interiorRef,
    placement,
    children,
    className,
  } = props;

  return (
    <div>
      <div className="PopoverScrim" />
      <div className="PopoverContainer">
        <Popper referenceElement={referenceElement} placement={placement}>
          {(props: PopperChildrenProps) => {
            const { ref, ...nonRefProps } = props;
            return (
              <PopoverInterior
                {...nonRefProps}
                popperRef={props.ref}
                localPopoverRef={interiorRef}
                className={className}
              >
                {children}
              </PopoverInterior>
            );
          }}
        </Popper>
      </div>
    </div>
  );
}

function PopoverInterior(
  props: {
    localPopoverRef?: React.Ref<HTMLDivElement>;
    popperRef: React.Ref<HTMLDivElement>;
    className?: string;
    children: React.ReactNode;
  } & Omit<PopperChildrenProps, "ref">,
) {
  const {
    popperRef,
    style,
    placement,
    arrowProps,
    localPopoverRef,
    className,
    children,
  } = props;
  return (
    <div
      className={`Popover ${className || ""}`}
      ref={useMergedRefs(localPopoverRef, popperRef)}
      style={style}
    >
      {children}
      <div
        className="Arrow"
        ref={arrowProps.ref}
        style={arrowProps.style}
        data-placement={placement}
      ></div>
    </div>
  );
}
